import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/form/_layout")({
    component: () => <FormLayout />,
    loader: ({ context: { t } }) => ({
        breadcrumb: t("pages.tool.design.form.title"),
    }),
});

function FormLayout() {
    return <Outlet />;
}
